export default {
  title: 'Токены',

  titles: {
    create: 'Создать токен',
    update: 'Изменить название токена',
    remove: 'Удалить токен',
    copy: 'Скопировать токен',
    expiredAt: 'Выберите дату истечения',

    update: {
      ipWhitelist: 'Обновить список белых IP-адресов'
    }
  },

  labels: {
    token: 'Токен',
    description: 'Название',
    search: 'Поиск',
    owner: 'Владелец',

    noData: {
      description: 'Нет названия',
      expiredAt: 'Нет даты',
      createAt: 'Нет даты'
    },

    expiredAt: 'Дата истечения',

    update: {
      ipWhitelist: 'Обновить список белых IP-адресов'
    }
  },

  hints: {
    notFound: 'Токены не найдены',
    description: 'Максимум 255 символов',
    ipWhitelist: `
<div>Хотите ограничить доступ к вашему токену по IP?</div>
<div>Администраторы могут добавить белый список IP-адресов для этого токена.</div>
<div>Если вам нужна эта функция, обратитесь в поддержку и предоставьте:</div>
<ul>
  <li>Название токена</li>
  <li>Дата создания токена</li>
  <li>Список IP-адресов для доступа (через запятую)</li>
</ul>
`
  },

  tooltips: {
    favorites: 'Сделать токен избранным',
    copy: 'Скопировать токен',
    sensitivity: 'Показать токен',

    update: {
      ipWhitelist: 'Обновить список белых IP-адресов'
    }
  },

  buttons: {
    create: 'Создать новый токен',
    add: 'Добавить токен'
  },

  warnings: {
    token: `
<strong>Внимание!</strong><br>
Это единственный момент, когда вы сможете увидеть и скопировать ваш токен.<br>
После закрытия этого окна он станет недоступен для просмотра.<br>
Пожалуйста, сохраните токен в надежном месте, так как впоследствии вы сможете лишь удалить его и создать новый.<br>
<br>
<span class="text--grey">Чтобы предотвратить случайное закрытие, окно заблокировано на 15 секунд (таймер отображается рядом с кнопкой закрытия).</span>`
  },

  snackbars: {
    created: 'Токен успешно создан.',
    removed: 'Токен успешно удалён.',
    updated: 'Токен успешно обновлён.',
    copy: 'Токен скопирован в буфер обмена.'
  }
}
